<div class="dialog-box card">
  @if (currentStatus === "profileDetails") {
    <form [formGroup]="profileForm" appFormEnterAction>
      @if (currentStep === 1) {
        <div class="card-header">Enter your details</div>
        <div class="d-flex flex-column gap-2">
          <div class="form-floating">
            <input
              class="form-control"
              type="text"
              id="first_name"
              formControlName="first_name"
              autocomplete="off"
              placeholder="First Name"
              maxlength="150"
              autofocus
            />
            <label>First Name</label>
          </div>
          <div class="form-floating">
            <input
              class="form-control"
              type="text"
              id="last_name"
              formControlName="last_name"
              autocomplete="off"
              placeholder="Last Name"
              maxlength="150"
              autofocus
            />
            <label>Last Name</label>
          </div>
          <div class="form-floating">
            <input
              class="form-control"
              id="mobile_number"
              formControlName="mobile_number"
              autocomplete="off"
              placeholder="Mobile (Optional)"
              autofocus
              type="tel"
              inputmode="numeric"
              pattern="[0-9]*"
              minlength="7"
              maxlength="10"
              pattern="\d*"
            />
            <label>Mobile (Optional)</label>
          </div>
          <div class="col-12 form-floating">
            <select
              class="form-control"
              formControlName="time_zone"
              id="timeZone"
            >
              @for (timeZone of stateTimeZones; track timeZone) {
                <option [value]="timeZone.value">
                  {{ timeZone.value }} {{ timeZone.gmtOffset }}
                </option>
              }
            </select>
            <label for="timeZone">Timezone</label>
          </div>
        </div>
        <div class="row row-col-2 mt-3">
          <div class="col col-6 offset-6">
            @if (isSuperUser || isPrimeContractorUser) {
              <button
                type="button"
                (click)="updateProfileData()"
                class="btn btn-primary btn-lg w-100"
                [disabled]="!profileForm.valid"
                (click)="updateProfileData()"
              >
                Submit
              </button>
            } @else {
              <button
                type="button"
                class="btn btn-primary btn-lg w-100"
                [disabled]="!profileForm.valid"
                (click)="currentStep = 2"
              >
                Next
              </button>
            }
          </div>
        </div>
      }
      @if (currentStep === 2) {
        <div class="card-header">Add Credentials</div>
        <gtapp-add-edit-identification
          [identificationForm]="identificationForm"
          showFrom="signUpPage"
        ></gtapp-add-edit-identification>
        <div class="row row-cols-2 mt-3">
          <div class="col-6">
            <button
              type="button"
              class="btn btn-secondary btn-lg w-100"
              (click)="currentStep = 1"
            >
              Back
            </button>
          </div>
          @if (!identificationForm.valid) {
            <div class="col-6">
              <button
                type="button"
                (click)="updateProfileData()"
                class="btn btn-primary btn-lg w-100"
                [disabled]="identificationForm.valid"
              >
                Skip & Add Later
              </button>
            </div>
          }
          @if (identificationForm.valid) {
            <div class="col-6">
              <button
                type="button"
                (click)="updateProfileData()"
                class="btn btn-primary btn-lg w-100"
              >
                Submit
              </button>
            </div>
          }
        </div>
      }
    </form>
  }
  @if (currentStatus === "passwordSet") {
    <div class="card-header">
      {{ addCancelButton ? "Change Password" : "Set Password" }}
      @if (addCancelButton) {
        <span class="float-end" (click)="onCloseDialogue()">
          <i class="fa-solid fa-xmark"></i>
        </span>
      }
    </div>
    <form
      [formGroup]="passwordForm"
      (ngSubmit)="changePassword()"
      appFormEnterAction
    >
      <div class="row row-cols-1 g-3 mt-1">
        <div>
          <div class="input-group">
            <div class="form-floating">
              <input
                class="form-control"
                [type]="showPassword ? 'text' : 'password'"
                name="password"
                id="password"
                formControlName="password"
                placeholder="New Password"
                minlength="8"
                [ngClass]="{
                  'is-invalid':
                    passwordForm.controls['password'].dirty &&
                    passwordForm.controls['password'].invalid,
                }"
              />
              <label for="password">New Password</label>
            </div>
            @if (showPassword === true) {
              <span class="input-group-text" (click)="toggleShowPassword()">
                <i class="fa-regular fa-eye"></i>
              </span>
            }
            @if (showPassword === false) {
              <span class="input-group-text" (click)="toggleShowPassword()">
                <i class="fa-regular fa-eye-slash"></i>
              </span>
            }
          </div>
          @if (passwordForm.controls["password"].hasError("minlength")) {
            <small class="text-danger"> Must have at least 8 characters </small>
          }
        </div>
        <div>
          <div class="form-floating">
            <input
              class="form-control"
              type="password"
              name="confirm_password"
              id="confirm_password"
              formControlName="confirm_password"
              placeholder="Confirm Password"
              minlength="8"
              [ngClass]="{
                'is-invalid':
                  passwordForm.controls['confirm_password'].dirty &&
                  passwordForm.controls['confirm_password'].invalid,
              }"
            />
            <label for="confirm_password">Confirm Password</label>
          </div>
          @if (
            passwordForm.controls["confirm_password"].value &&
            passwordForm.controls["confirm_password"].invalid
          ) {
            <small class="text-danger"> Passwords do not match </small>
          }
        </div>
      </div>
      <div class="row row-cols-2 mt-3">
        @if (addCancelButton) {
          <div class="col">
            <button
              class="btn btn-dark btn-lg w-100"
              (click)="onCloseDialogue()"
            >
              Cancel
            </button>
          </div>
        }
        <div class="col" [ngClass]="addCancelButton ? '' : 'offset-6'">
          <button
            [disabled]="!passwordForm.valid"
            type="submit"
            class="btn btn-primary btn-lg w-100"
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  }
  @if (currentStatus === "webauthn") {
    <div class="card-header">Sign In with a Passkey</div>
    @if (fidoError) {
      <div class="alert alert-danger">
        Something went wrong.
        <div class="small">
          Details:
          <div [innerHTML]="fidoError"></div>
        </div>
      </div>
      <div class="row row-cols-1 mt-3">
        <div class="col">
          <button class="btn btn-dark btn-lg w-100" (click)="onCloseDialogue()">
            Skip
          </button>
        </div>
      </div>
    } @else {
      <div class="p-2">Sign in using your fingerprint, face, or PIN code.</div>
      <div class="text-danger fw-semibold my-3 text-center">
        WARNING: DO NOT create a passkey if this is a shared device.
      </div>
      <div class="row row-cols-2 mt-3">
        <div class="col">
          <button
            type="submit"
            class="btn btn-outline-primary btn-lg w-100"
            (click)="fidoRegister()"
          >
            Create a Passkey
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-primary btn-lg w-100"
            (click)="onCloseDialogue()"
          >
            Skip
          </button>
        </div>
      </div>
    }
  }
  @if (currentStatus === "webauthnSuccess") {
    <div class="card-header">Passkey Created</div>
    <div class="alert alert-success">
      You can now sign in using a passkey instead of typing your password.
    </div>
    <div class="row row-cols-1 mt-3">
      <div class="col">
        <button
          class="btn btn-success btn-lg w-100"
          (click)="onCloseDialogue()"
        >
          OK
        </button>
      </div>
    </div>
  }
</div>
